import {
  FETCH_GAME_INFO,
  FETCH_GAME_INFO_SUCCESS,
  FETCH_GAME_INFO_FAILED,
  CREATE_GAME,
  CREATE_GAME_FAILED,
  CREATE_GAME_SUCCESS,
  RESET,
  LEAVE_GAME,
  LEAVE_GAME_FAILED,
  LEAVE_GAME_SUCCESS,
  ENTER_GAME,
  ENTER_GAME_FAILED,
  ENTER_GAME_SUCCESS
} from "../actions/types";
import { auth } from "../../App";

export type PlayersType =
  | "player_0"
  | "player_1"
  | "player_2"
  | "player_3"
  | "player_4"
  | "player_5"
  | "player_6"
  | "player_7";

export interface PlayerResults {
  haveSeen: boolean;
  imageUrl: string;
  votesReceived?: PlayersType[];
  score: number;
}
export interface LatestResultsInterface {
  concept: string;
  round: number;
  player_speaker: PlayersType;
  player_0: PlayerResults;
  player_1: PlayerResults;
  player_2: PlayerResults;
  player_3: PlayerResults;
  player_4?: PlayerResults;
  player_5?: PlayerResults;
  player_6?: PlayerResults;
  player_7?: PlayerResults;
}
export interface GameInfo {
  cards: string[];
  currentPlayers: number;
  freePlayersGameId: {
    [key: number]: string;
  };
  gameName: string;
  id: string;
  isPublic: boolean;
  maxPlayers: number;
  maxScore: number;
  moderator: string;
  latest_results?: LatestResultsInterface;
  players: {
    [key in PlayersType]: {
      id: string;
      score: number;
    };
  };
  started: boolean;
  status: "room" | "playing";
}

export interface gameActionInterface {
  type: string;
  payload?: GameInfo;
}
export interface GameInterface {
  errorFetching: string;
  loading: boolean;
  playing: boolean;
  myPlayerId?: PlayersType;
  info?: GameInfo;
}

const INITIAL_STATE: GameInterface = {
  errorFetching: "",
  loading: false,
  info: undefined,
  playing: false,
  myPlayerId: undefined
};

var myPlayerId: PlayersType;
const game = (
  state: GameInterface = INITIAL_STATE,
  action: gameActionInterface
): GameInterface => {
  switch (action.type) {
    case ENTER_GAME:
      return {
        ...state,
        ...INITIAL_STATE,
        loading: true
      };
    case ENTER_GAME_FAILED:
      return {
        ...INITIAL_STATE,
        ...state,
        errorFetching: "Couldn't enter game.",
        loading: false
      };
    case ENTER_GAME_SUCCESS:
      return {
        ...INITIAL_STATE,
        ...state,
        loading: false
      };
    case CREATE_GAME:
      return {
        ...INITIAL_STATE,
        ...state,
        loading: true
      };
    case CREATE_GAME_FAILED:
      return {
        ...INITIAL_STATE,
        ...state,
        errorFetching: "Couldn't create game.",
        loading: false
      };
    case CREATE_GAME_SUCCESS:
      return {
        ...INITIAL_STATE,
        ...state,
        loading: false,
        playing: true
      };
    case LEAVE_GAME:
      return {
        ...state,
        ...INITIAL_STATE,
        loading: true
      };
    case LEAVE_GAME_FAILED:
      return {
        ...INITIAL_STATE,
        ...state,
        errorFetching: "Couldn't leave game.",
        loading: false
      };
    case LEAVE_GAME_SUCCESS:
      return {
        ...INITIAL_STATE,
        ...state,
        loading: false,
        info: undefined,
        playing: false,
        myPlayerId: undefined
      };
    case FETCH_GAME_INFO:
      return {
        ...INITIAL_STATE,
        ...state,
        loading: true
      };
    case FETCH_GAME_INFO_SUCCESS:
      const { currentUser } = auth;
      if (action.payload === undefined) {
        return {
          ...state,
          loading: false,
          errorFetching: "No payload"
        };
      }
      Object.keys(action.payload.players).forEach((playerId2: any) => {
        const playerId = playerId2 as PlayersType;
        if (action.payload === undefined) {
          return {
            ...state,
            loading: false,
            errorFetching: "No payload"
          };
        }
        if (action.payload.players[playerId].id === currentUser?.uid) {
          myPlayerId = playerId;
        }
      });
      return {
        ...state,
        loading: false,
        errorFetching: "",
        info: action.payload,
        playing: true,
        myPlayerId
      };

    case FETCH_GAME_INFO_FAILED:
      return {
        ...state,
        loading: false,
        errorFetching: "Couldn't fetch game info.",
        info: undefined,
        playing: false
      };
    case RESET:
      return {
        ...state,
        loading: false,
        errorFetching: "",
        info: undefined
      };

    default:
      return state;
  }
};

export default game;
